import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";
import { MessageFiltersEnum } from "../../../features/Library/Communications/Messages/types/models";

export const getMessagesFilters = (disableDateFilters: boolean = false): FilterItemBase<MessageFiltersEnum>[] => {
  let filters: FilterItemBase<MessageFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: MessageFiltersEnum.DateCreated,
      otherProps: { disabled: disableDateFilters },
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: MessageFiltersEnum.DateModified,
      otherProps: { disabled: disableDateFilters },
    },
  ];

  return filters;
};
